<template>
  <div :class="containerClasses">
    <ToggleSwitch
      class="switch"
      unstyled
      v-model="localModelValue"
      :pt="{
        slider: () => ({ class: switchClasses }),
        root: () => ({ class: { checked: props.modelValue } }),
      }"
      inputClass="inputbox"
      :disabled="disabled"
    />
    <span v-if="text" class="switch-label">{{ text }}</span>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, computed } from "vue";
import ToggleSwitch from "primevue/toggleswitch";

const props = defineProps({
  modelValue: null,
  disabled: { type: Boolean, default: false },
  type: {
    type: String,
    default: "primary",
  },
  text: String,
  direction: String,
});

const emit = defineEmits(["update:modelValue"]);
const containerClasses = computed(() => [
  "flex",
  "gap-4",
  "items-center",
  {
    "flex-col flex-col-reverse": props.direction === "top",
    "flex-col": props.direction === "bottom",
    "flex-row-reverse": props.direction === "left",
  },
]);

const switchClasses = computed(() => {
  const baseClass = "switch-slider";
  const typeClass = `switch-slider-${props.type}`;
  const stateClass = props.modelValue ? typeClass : "switch-slider-primary";

  return `${baseClass} ${stateClass}`;
});

const localModelValue = computed({
  get: () => props.modelValue,
  set: value => emit("update:modelValue", value),
});
</script>
